import {
  React,
  Slider,
  PropTypes
} from '../libraries'

export const Banner = (props) => {
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  return (
    <>
      <Slider {...settings}>
        {[0, 1, 2, 3, 4].map(ele => {
          return <div className='header-bg text-white' key={ele + 1} />
        })}
      </Slider>
    </>
  )
}

Banner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string

}

Banner.defaultProps = {
  title: 'Title',
  description: 'Description'
}
